import { AsyncPipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ChatbotComponent } from '@components/chatbot/chatbot.component';
import { HeaderBarComponent } from '@components/header-bar/header-bar.component';
import { Store } from '@ngrx/store';
import { State } from '@store/state';
import { initUserAuthorizations } from '@store/user-infos/user-infos.action';
import {
  getIsUserAuthorizedToConfigureThresholds,
  getIsUserAuthorizedToTeamsCampaign,
} from '@store/user-infos/user-infos.selector';
import { Observable, startWith } from 'rxjs';
import { TagCommanderService } from 'ngx-tag-commander'; // EasyTrack: TagCommanderService
import { environment } from '@environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'tmn-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderBarComponent,
    ChatbotComponent, // Chatbot component hosting the <mini-chatbot> web component
    AsyncPipe
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {

  public isUserAuthorizedToTeamsCampaign$: Observable<boolean> = this.store.select(
    getIsUserAuthorizedToTeamsCampaign
  ).pipe(
    startWith(false)
  );

  public hasRightToConfigureThresholds$: Observable<boolean> = this.store.select(
    getIsUserAuthorizedToConfigureThresholds
  ).pipe(
    startWith(false)
  );

  constructor(
    public store: Store<State>,
    private tcService: TagCommanderService,
    private oauthService: OAuthService
  ) {
    registerLocaleData(localeFr, 'fr');
    const userId = (this.oauthService.getIdentityClaims() as Record<string, string>)?.['mat'] ?? '';
    tcService.setTcVars({
      env_work: environment.production ? 'production' : 'staging',
      user_id: userId,
      page_name: ''
    }); // Pose les vars globales avant le chargement du container
    Promise.all([
      tcService.addContainer('container_body', environment.tcContainerUrl, 'body'), // EasyTrack: add container
    ]);
  }

  ngOnInit() {
    this.store.dispatch(initUserAuthorizations());
  }

}
